import { ProviderBuilder, EGenMode } from '@educraft/base';
import { Prirazeni } from './generators/Prirazeni';
import { PrirazeniBarvy } from './generators/PrirazeniBarvy';
import { Lepitka } from './generators/Lepitka';
import { PocitaniHex } from './generators/PocitaniHex';
import { ObrazekRovnice } from './generators/ObrazekRovnice';
import { PocitaniSlova } from './generators/PocitaniSlova';

export function registerLayoutImageSingle(builder: ProviderBuilder) {
  builder.add(EGenMode.LayoutImageSingle, Prirazeni, 'ImageSingle.Prirazeni');
  builder.add(EGenMode.LayoutImageSingle, PrirazeniBarvy, 'ImageSingle.PrirazeniBarvy');
  builder.add(EGenMode.LayoutImageSingle, Lepitka, 'ImageSingle.Lepitka');
  builder.add(EGenMode.LayoutImageSingle, PocitaniHex, 'ImageSingle.PocitaniHex');
  builder.add(EGenMode.LayoutImageSingle, ObrazekRovnice, 'ImageSingle.ObrazekRovnice');
  builder.add(EGenMode.LayoutImageSingle, PocitaniSlova, 'ImageSingle.PocitaniSlova');
}
